import styled from 'styled-components';

export const StyledAddCardRow = styled.div<{ $showDivider?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: ${props =>
    props.$showDivider ? '1px solid var(--Color-Set-horizontal-vertical-rule, #C4C4C4)' : 'none'};
  padding-top: ${props => (props.$showDivider ? '24px' : '0')};
  width: 100%;
`;
